import {
  ButtonActionType,
  ButtonSizeOptions,
  ButtonTypes,
  cryptoRandomUUID,
  WidgetNames,
} from '@finxone-platform/shared/sys-config-types';
import { FormID } from '@finxone-platform/form-action';
import { UUID } from '@finxone-platform/shared/base-types';

export const saveTransactionNoteFormChildComponents = [
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: WidgetNames.INPUT_WIDGET,
    widgetConfiguration: {
      widgetDisplayName: 'Input',
      widgetConfigDisplayName: 'Input',
      attributes: {
        elementsConfig: [],
        name: WidgetNames.INPUT_WIDGET,
        css_config: {},
        widgetProperties: {
          textContent: '',
          inputFieldConfig: {
            id: 'note',
            type: 'text',
            label: 'Note',
            parentForm: FormID.SAVE_TRANSACTION_NOTE_FORM,
            name: 'note',
            validation: {
              required: true,
              phoneNumber: false,
              email: false,
            },
            inputFormat: 'short-text-input',
            fieldRequired: true,
            inputPlaceholder: 'Enter a note',
            inputHelperText: '',
            inputLabelTooltipText: '',
          },
          disableAutocomplete: false,
        },
      },
      isRemovable: true,
      nestedWidgets: {},
    },
    widgetIconPath: 'input-field-widget',
  },
  {
    name: 'spacer-widget',
    uniqueId: new UUID().toString(),
    widgetIconPath: 'spacer-widget',
    widgetTypeConfig: 'new',
    widgetConfiguration: {
      attributes: {
        outerCss: '',
        css_config: {
          height: '30',
          heightUnit: 'px',
        },
        elementsConfig: [],
        widgetProperties: {
          textContent: '',
        },
      },
      isRemovable: true,
      widgetDisplayName: 'Spacer',
      widgetConfigDisplayName: 'Spacer',
    },
  },
  {
    widgetTypeConfig: 'new',
    uniqueId: cryptoRandomUUID(),
    name: 'action_button_widget',
    widgetConfiguration: {
      uniqueId: cryptoRandomUUID(),
      widgetDisplayName: 'Action Button Widget',
      widgetConfigDisplayName: 'Action Button',
      isRemovable: true,
      attributes: {
        elementsConfig: [],
        label: '',
        sub_heading: '',
        show: true,
        css_config: {
          fontUnit: 'px',
          textInputFontUnit: 'px',
          righticonSize: 20,
          lefticonSize: 20,
          iconUnit: 'px',
          leftIconUnit: 'px',
          rightIconUnit: 'px',
          width: 60,
          height: 60,
          dimensionUnit: 'px',
        },
        widgetProperties: {
          textContent: 'Save',
          buttonActionType: ButtonActionType.SAVE_TRANSACTION_NOTE,
          globalStyling: true,
          globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
        },
      },
    },
    widgetIconPath: 'action-button',
  },
];
